import { addLocaleData } from 'react-intl';
import pt from 'react-intl/locale-data/pt';

import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';
import navPt from '@99designs/common/apps/global-nav/locale-data/pt';

setNavTranslations(navPt);
addLocaleData(pt);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/pt.js